import { Autocomplete } from "@mui/lab";
import { FormControl, MenuItem, Select, TextField } from "@mui/material";
import LoadingScreen from "base/ui/components/LoadingScreen/loadingScreen";
import Pagination from "base/ui/components/Pagination/pagination";
import { observer } from "mobx-react-lite";
import moment from "moment";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { AiFillEye } from "react-icons/ai";
import { FaCheck } from "react-icons/fa";
import { HiSearch } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import {
  CommonDate,
  ListDate,
  ListStatusProduct,
} from "services/commonDate_services";
import {
  MCCommandModel,
  SearchMCCommand,
} from "services/matchCardCommand_services";
import * as rootStore from "stores/root_store";
import { PAGE_SIZE_DEFAULT } from "utils/constants";
import { formatNumber } from "utils/formatHelper";

type DateSelect = {
  currentDate: string;
  dateFrom: string;
  dateTo: string;
};

export function createMatchCardCommand() {
  return observer(() => {
    const navigate = useNavigate();

    const column = [
      {
        columnName: "STT",
        key: "stt",
        align: "text-center",
        visible: true,
      },
      {
        columnName: "Lệnh thiết kế",
        key: "matchCardCode",
        align: "text-center",
        visible: true,
        render: (record: MCCommandModel) => {
          return (
            <Link
              className="text-primary"
              to={`matchCardCommandId=${record.matchCardCommandId}`}
            >
              {record.matchCardCode}
            </Link>
          );
        },
      },

      {
        columnName: "Tên hạng mục in",
        key: "printItem",
        align: "text-left",
        visible: true,
      },

      {
        columnName: "Số phiếu thiết kế",
        key: "designVote",
        align: "text-left",
        visible: true,
      },

      {
        columnName: "Phụ trách thiết kế",
        key: "designBy",
        align: "text-left",
        visible: true,
      },
      {
        columnName: "Kiểu in",
        key: "printStyle",
        align: "text-left",
        visible: true,
      },

      {
        columnName: "Công ty gia công in",
        key: "printCompany",
        align: "text-left",
        visible: true,
      },
      {
        columnName: "NCC kẽm",
        key: "zincSupplier",
        align: "text-left",
        visible: true,
      },
      {
        columnName: "LSX",
        align: "text-center",
        visible: true,
        key: "workOrderCode",
      },
      {
        columnName: "Ngày ban hành LSX",
        key: "documentDate",
        align: "text-center",
        visible: true,
        dataType: "date",
      },
      {
        columnName: "Ngày yêu cầu có hàng in",
        key: "printReqDate",
        align: "text-center",
        visible: true,
        dataType: "date",
      },

      {
        columnName: "Mã sản phẩm",
        align: "text-center",
        visible: true,
        key: "productCode",
      },
      {
        columnName: "Tên sản phẩm",
        align: "text-left",
        visible: true,
        key: "productName",
      },
      {
        columnName: "Ngày yêu cầu nhập kho",
        align: "text-center",
        visible: true,
        dataType: "date",
        key: "deliveryDate",
      },
      {
        columnName: "Đã chia tỷ lệ ghép bài",
        align: "text-center",
        visible: true,
        key: "isMatchCard",
        render: (record: MCCommandModel) => {
          return record.isMatchCard ? (
            <FaCheck className="text-blue-700 text-lg text-center mx-auto" />
          ) : (
            ""
          );
        },
      },
      // {
      //   columnName: "Tỷ lệ ghép bài",
      //   align: "text-center",
      //   visible: true,
      //   key: "isMatchCard",
      // },
      {
        columnName: "Số PO/Hợp đồng/Báo giá",
        align: "text-left",
        visible: true,
        key: "poCode",
      },
      {
        columnName: "Trạng thái Netsuite",
        align: "text-left",
        visible: true,
        key: "workOrderNetsuiteStatus",
      },
      {
        columnName: "Trạng thái MES",
        align: "text-left",
        visible: true,
        key: "workOrderMesStatus",
      },
    ];

    const Style = {
      ".MuiOutlinedInput-root": {
        padding: 0,
      },
      ".MuiOutlinedInput-input": {
        fontSize: "13px",
      },
      ".MuiOutlinedInput-notchedOutline": { borderRadius: 0 },
      ".MuiAutocomplete-listbox": { fontSize: "13px !important" },
    };

    // ================== STATE ======================
    // list date
    const [listDate, setlistDate] = useState<ListDate[]>([]);
    // current date
    const [dateLSXSelected, setDateLSXSelected] = useState<DateSelect>({
      currentDate: "",
      dateFrom: "",
      dateTo: "",
    });
    const [datePrintReqSelected, setDatePrintReqSelected] = useState<
      DateSelect
    >({
      currentDate: "",
      dateFrom: "",
      dateTo: "",
    });
    // loading page
    const [isLoading, setIsLoading] = useState(true);
    //Trạng thái Netsuite
    const [netsuiteStatus, setNetsuiteStatus] = useState<ListStatusProduct[]>(
      []
    );
    // list Trạng thái MES
    const [mesStatus, setMesStatus] = useState<ListStatusProduct[]>([]);

    const [searchData, setSearchData] = useState<SearchMCCommand>({
      paging: {
        pageIndex: 1,
        pageSize: PAGE_SIZE_DEFAULT,
      },
      matchCardCode: undefined,
      printItem: undefined,
      designVote: undefined,
      printCompany: undefined,
      fromDocumentDate: undefined,
      toDocumentDate: undefined,
      fromPrintReqDate: undefined,
      toPrintReqDate: undefined,
      isMatchCard: "false",
    });

    const { register, handleSubmit, setValue, control } = useForm<
      SearchMCCommand
    >({
      defaultValues: {
        isMatchCard: "false",
      },
    });
    // ================== FUNCTION ===================

    // Hàm lấy dropdown trạng thái MES
    const getListDropDownMesStatus = async (
      keywword = "WorkOrderStatusMes"
    ) => {
      await rootStore.commonDatePresenter.getDropdownByKeyword(
        rootStore.commonDateStore,
        keywword
      );
      setMesStatus([
        {
          key: "",
          value: "-- Tất cả --",
        },
        ...rootStore.commonDateStore.dropdownByKey,
      ]);
    };
    // Hàm lấy dropdown Trạng thái Netsuite

    const getListDropDownNetsuiteStatus = async (
      keywword = "WorkOrderStatus"
    ) => {
      await rootStore.commonDatePresenter.getDropdownByKeyword(
        rootStore.commonDateStore,
        keywword
      );

      setNetsuiteStatus([
        {
          key: "",
          value: "-- Tất cả --",
        },
        ...rootStore.commonDateStore.dropdownByKey,
      ]);
    };

    const handleChangePageSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
      const search = {
        ...searchData,
        isMatchCard: JSON.stringify(searchData.isMatchCard),
        paging: {
          pageSize: parseInt(e.target.value),
          pageIndex: 1,
        },
      };
      setSearchData(search);

      onSearch(search);
    };
    const handleChangePageIndex = (data: any) => {
      const search = {
        ...searchData,
        isMatchCard: JSON.stringify(searchData.isMatchCard),
        paging: {
          pageSize: searchData.paging.pageSize,
          pageIndex: data.selected + 1,
        },
      };
      setSearchData(search);
      onSearch(search);
    };

    // search
    const onSearch = async (data: SearchMCCommand) => {
      setIsLoading(true);
      const valueForm = {
        mesStatus: data.mesStatus || undefined,
        netsuiteStatus: data.netsuiteStatus || undefined,
        isMatchCard: data.isMatchCard
          ? JSON.parse(data.isMatchCard || "")
          : undefined,
        matchCardCode: data.matchCardCode || undefined,
        printItem: data.printItem || undefined,
        designVote: data.designVote || undefined,
        printCompany: data.printCompany || undefined,
        fromDocumentDate: data.fromDocumentDate || undefined,
        toDocumentDate: data.toDocumentDate || undefined,
        fromPrintReqDate: data.fromPrintReqDate || undefined,
        toPrintReqDate: data.toPrintReqDate || undefined,
      };
      setSearchData({
        paging: data.paging
          ? data.paging
          : {
            pageIndex: 1,
            pageSize: searchData.paging.pageSize,
          },
        ...valueForm,
      });

      await rootStore.mCComandPresenter.getListMCCommand(
        rootStore.mCComandStore,
        {
          paging: data.paging
            ? data.paging
            : {
              pageIndex: 1,
              pageSize: searchData.paging.pageSize,
            },
          ...valueForm,
        }
      );
      setIsLoading(false);
    };

    // các row trong table lấy từ store
    const tableRows = rootStore.mCComandStore.mCCommand.data;

    // ================== EFFECT =====================
    useEffect(() => {
      const getListDate = async () => {
        await rootStore.commonDatePresenter.getListCommonDate(
          rootStore.commonDateStore
        );
        setlistDate(rootStore.commonDateStore.listDate.data);
      };
      getListDate();
      onSearch(searchData);
      getListDropDownMesStatus();
      getListDropDownNetsuiteStatus();
    }, []);

    return (
      <div className="w-full py-3 px-5">
        {isLoading && <LoadingScreen />}
        <div className="mb-2">
          <h3 className="text-md font-bold text-gray-800 mb-2 uppercase">
            LỆNH GHÉP BÀI
          </h3>
        </div>

        {/* Form nhập tìm kiếm */}
        <div className="w-full bg-white p-3.5 flex rounded mb-2 border border-neutral-300">
          <form className="w-full lg:grid lg:grid-cols-2 flex flex-col md:gap-x-5 gap-2">
            {/* Lệnh thiết kế*/}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className=" font-medium text-default text-gray-700 sm:text-end">
                Lệnh thiết kế
              </label>
              <input
                {...register("matchCardCode")}
                className="col-span-2 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* Công ty gia công in*/}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className=" font-medium text-default text-gray-700 sm:text-end">
                Công ty gia công in
              </label>
              <input
                {...register("printCompany")}
                className="col-span-2 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* Tên hạng mục in*/}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className=" font-medium text-default text-gray-700 sm:text-end">
                Tên hạng mục in
              </label>
              <input
                {...register("printItem")}
                className="col-span-2 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* Số phiếu thiết kế*/}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className=" font-medium text-default text-gray-700 sm:text-end">
                Số phiếu thiết kế
              </label>
              <input
                {...register("designVote")}
                className="col-span-2 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>

            {/* Trạng thái MES */}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className=" font-medium text-default text-gray-700 sm:text-end">
                Trạng thái MES
              </label>
              <FormControl className="col-span-2">
                <Select
                  {...register("mesStatus")}
                  className="text-gray-700 hover:ring-0 hover:outline-none hover:border-gray-300 !rounded-none border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  displayEmpty
                  sx={{
                    height: 35,
                  }}
                  defaultValue={""}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  {mesStatus.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item.key}>
                        <span className="text-default">{item.value}</span>
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {/* trạng thái Netsuite */}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className=" font-medium text-default text-gray-700 sm:text-end">
                Trạng thái Netsuite
              </label>
              <FormControl className="col-span-2">
                <Select
                  {...register("netsuiteStatus")}
                  className=" text-gray-700 hover:ring-0 hover:outline-none hover:border-gray-300 !rounded-none border-border_input sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  displayEmpty
                  sx={{
                    height: 35,
                  }}
                  inputProps={{ "aria-label": "Without label" }}
                  defaultValue={""}
                >
                  {netsuiteStatus.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item.key}>
                        <span className="text-default">{item.value}</span>
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {/* Đã chia tỉ lệ ghép bài */}
            <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className=" font-medium text-default text-gray-700 sm:text-end">
                Chia tỷ lệ ghép bài
              </label>
              {/* <input
                {...register("designVote")}
                className="col-span-2 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              /> */}
              <div className="flex gap-3 col-span-2 text-default text-gray-700 sm:ml-5">
                <span className="flex items-center gap-1">
                  <input
                    {...register("isMatchCard")}
                    value={"true"}
                    type="radio"
                    id="daChia"
                  />
                  <label htmlFor="daChia">Đã chia tỷ lệ ghép bài</label>
                </span>
                <span className="flex items-center gap-1">
                  <input
                    {...register("isMatchCard")}
                    value={"false"}
                    type="radio"
                    id="chuaChia"
                  />
                  <label htmlFor="chuaChia">Chưa chia tỷ lệ ghép bài</label>
                </span>
                <span className="flex items-center gap-1">
                  <input
                    {...register("isMatchCard")}
                    value={"null"}
                    type="radio"
                    id="tatCa"
                  />
                  <label htmlFor="tatCa">Tất cả</label>
                </span>
              </div>
            </div>

            {/* Ngày ra LSX*/}
            <div className="w-full sm:flex-row  sm:items-center grid sm:grid-cols-3 grid-cols-1 col-start-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 sm:text-end">
                Ngày ban hành LSX
              </label>
              <Autocomplete
                className="col-span-2 text-gray-700 p-0 text-default hover:ring-0 hover:outline-none hover:border-gray-300 !rounded-none border-gray-300 sm:ml-5 t focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                // id="disabled-options-demo"
                options={listDate}
                sx={Style}
                classes={{
                  listbox: "text-default",
                  input: "!text-gray-700",
                  noOptions: "text-default",
                }}
                // onChange={handleChangeDateLSX}
                onChange={async (e, value) => {
                  if (value) {
                    setDateLSXSelected({
                      ...dateLSXSelected,
                      currentDate: value.key,
                    });
                    await rootStore.commonDatePresenter.getDataByCommonDate(
                      rootStore.commonDateStore,
                      value.key
                    );
                    setValue(
                      "fromDocumentDate",
                      rootStore.commonDateStore.commonDate.fromDate
                    );
                    setValue(
                      "toDocumentDate",
                      rootStore.commonDateStore.commonDate.toDate
                    );
                  } else {
                    setDateLSXSelected({ ...dateLSXSelected, currentDate: "" });
                    setValue("fromDocumentDate", undefined);
                    setValue("toDocumentDate", undefined);
                  }
                }}
                getOptionLabel={(option) => option.value}
                renderInput={(params) => <TextField {...params} />}
              />
            </div>

            {/* từ ngày */}
            <div className="w-full sm:flex-row  sm:items-center grid sm:grid-cols-3 grid-cols-1 col-start-1">
              <label className=" font-medium text-default text-gray-700 sm:text-end">
                Từ Ngày
              </label>
              <input
                {...register("fromDocumentDate")}
                disabled={
                  dateLSXSelected.currentDate !== "Custom" &&
                  dateLSXSelected.currentDate !== ""
                }
                // value={dateLSX?.fromDate || dateLSXSelected.dateFrom}
                type="date"
                onChange={(e) =>
                  setDateLSXSelected({
                    ...dateLSXSelected,
                    dateFrom: e.target.value,
                  })
                }
                className="col-span-2 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* đến ngày */}
            <div className="w-full sm:flex-row  sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className=" font-medium text-default text-gray-700 sm:text-end">
                Đến ngày
              </label>
              <input
                {...register("toDocumentDate")}
                disabled={
                  dateLSXSelected.currentDate !== "Custom" &&
                  dateLSXSelected.currentDate !== ""
                }
                // value={dateLSX?.toDate || dateLSXSelected.dateTo}
                type="date"
                onChange={(e) =>
                  setDateLSXSelected({
                    ...dateLSXSelected,
                    dateTo: e.target.value,
                  })
                }
                className="col-span-2 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>

            {/* Ngày yêu cầu có hàng in*/}
            <div className="w-full sm:flex-row  sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className="min-w-[150px] font-medium text-default text-gray-700 sm:text-end">
                Ngày yêu cầu có hàng in
              </label>
              <Autocomplete
                className="col-span-2 text-gray-700 p-0 text-default hover:ring-0 hover:outline-none hover:border-gray-300 !rounded-none border-gray-300 sm:ml-5 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                id="disabled-options-demo"
                options={listDate}
                sx={Style}
                classes={{
                  listbox: "text-default",
                  input: "!text-gray-700",
                  noOptions: "text-default",
                }}
                // onChange={handleChangePrintReqDate}
                onChange={async (e, value) => {
                  if (value) {
                    setDatePrintReqSelected({
                      ...datePrintReqSelected,
                      currentDate: value.key,
                    });
                    await rootStore.commonDatePresenter.getDataByCommonDate(
                      rootStore.commonDateStore,
                      value.key
                    );
                    setValue(
                      "fromPrintReqDate",
                      rootStore.commonDateStore.commonDate.fromDate
                    );
                    setValue(
                      "toPrintReqDate",
                      rootStore.commonDateStore.commonDate.toDate
                    );
                  } else {
                    setDatePrintReqSelected({
                      ...datePrintReqSelected,
                      currentDate: "",
                    });
                    setValue("fromPrintReqDate", undefined);
                    setValue("toPrintReqDate", undefined);
                  }
                }}
                getOptionLabel={(option) => option.value}
                renderInput={(params) => <TextField {...params} />}
              />
            </div>
            <div></div>
            {/* từ ngày */}
            <div className="w-full sm:flex-row  sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className=" font-medium text-default text-gray-700 sm:text-end">
                Từ ngày
              </label>
              <input
                {...register("fromPrintReqDate")}
                type="date"
                disabled={
                  datePrintReqSelected.currentDate !== "Custom" &&
                  datePrintReqSelected.currentDate !== ""
                }
                // value={datePrintReq?.fromDate || datePrintReqSelected.dateFrom}
                onChange={(e) =>
                  setDatePrintReqSelected({
                    ...datePrintReqSelected,
                    dateFrom: e.target.value,
                  })
                }
                className="col-span-2 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>
            {/* đến ngày */}
            <div className="w-full sm:flex-row  sm:items-center grid sm:grid-cols-3 grid-cols-1">
              <label className=" font-medium text-default text-gray-700 sm:text-end">
                Đến ngày
              </label>
              <input
                {...register("toPrintReqDate")}
                type="date"
                disabled={
                  datePrintReqSelected.currentDate !== "Custom" &&
                  datePrintReqSelected.currentDate !== ""
                }
                // value={datePrintReq?.toDate || datePrintReqSelected.dateTo}
                onChange={(e) =>
                  setDatePrintReqSelected({
                    ...datePrintReqSelected,
                    dateTo: e.target.value,
                  })
                }
                className="col-span-2 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
              />
            </div>

            {/* button tìm kiếm */}
            <div className="w-full flex justify-center col-span-2 mt-1">
              <button
                onClick={handleSubmit(onSearch)}
                type="submit"
                className={`flex items-center text-white bg-blue-700 rounded text-default px-2.5 py-1 text-center focus:outline-none hover:bg-blue-600`}
              >
                <>
                  <HiSearch className="font-bold text-lg" />
                  Tìm kiếm
                </>
              </button>
            </div>
          </form>
        </div>

        {/* Table product */}
        <div className="w-full bg-white py-3 px-5 rounded border border-neutral-300">
          {/*=========== Pagination =======================*/}
          <Pagination
            pageCount={rootStore.mCComandStore.mCCommand.paging.totalPage}
            forcePage={searchData.paging.pageIndex - 1}
            onPageSizeChange={handleChangePageSize}
            onPageChange={handleChangePageIndex}
          />
          {/* =========== Table PO ===============*/}
          <div className={`overflow-x-auto my-3`}>
            <table className="w-full text-default table-auto border-collapse space-collapse text-default`">
              <thead className="font-medium text-gray-700 bg-gray-100">
                <tr>
                  {column?.map((item, index) => {
                    if (item.visible) {
                      return (
                        <th
                          key={index}
                          scope="col"
                          className={`${item.visible ? "" : "hidden"
                            } py-1.5 px-5 border whitespace-nowrap text-center`}
                        >
                          {item.columnName}
                        </th>
                      );
                    }
                  })}
                </tr>
              </thead>
              <tbody>
                {tableRows && tableRows.length ? (
                  tableRows?.map((row, index) => (
                    <tr key={index}>
                      {column.map((cell, indexcell) => (
                        <td
                          key={indexcell}
                          className={
                            "border whitespace-nowrap px-3 py-0.5 " +
                            `${cell.align && cell.align}`
                          }
                        >
                          {(() => {
                            if (cell.render) {
                              return cell.render(row);
                            } else {
                              if (cell.dataType === "number") {
                                return row[`${cell.key}`]
                                  ? formatNumber(Number(row[`${cell.key}`]), 0)
                                  : "";
                              } else if (cell.dataType === "date") {
                                return row[`${cell.key}`]
                                  ? moment(row[`${cell.key}`]).format(
                                    "DD/MM/YYYY"
                                  )
                                  : "";
                              } else if (cell.dataType === "dateTime") {
                                return row[`${cell.key}`]
                                  ? moment(row[`${cell.key}`]).format(
                                    "DD/MM/YYYY HH:mm:ss"
                                  )
                                  : "";
                              } else {
                                return row[`${cell.key}`];
                              }
                            }
                          })()}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      className="border whitespace-nowrap py-3  text-center"
                      colSpan={100}
                    >
                      Không tìm thấy dòng nào phù hợp
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <span className="block mt-3.5 text-default">
            Đang xem từ {`${tableRows && tableRows.length ? tableRows[0]?.stt : 0}`} đến {`${tableRows && tableRows.length ? tableRows[tableRows.length - 1]?.stt : 0}`} trong tổng số{' '}
            {`${rootStore.mCComandStore.mCCommand.paging.totalCount || 0}`} mục
          </span>
        </div>
      </div>
    );
  });
}
